import gql from 'graphql-tag';

const query = gql`
  query Settings {
    me {
      id
      agreements {
        dietCourse
        articles
        newsletter
      }
    }
  }
`;

export default query;
